<app-consulta-receita [(showDialog)]="showReceitaPesquisa"></app-consulta-receita>

<div class="flex flex-col items-center">
    <section class="w-[90%] flex justify-center flex-1">
        <div class="hero-banner w-full h-full p-8 md:p-16 flex flex-col md:flex-row items-center gap-10">
            <div class="flex-1 text-left flex flex-col justify-center">
                <span class="inline-block px-4 py-1 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-widest mb-6 self-start">Plataforma Unificada</span>
                <h1 class="text-4xl md:text-6xl font-extrabold mb-4 leading-tight tracking-tight">
                    Gestão Inteligente para <br class="hidden md:block" />
                    <span class="text-primary">Conselhos de Medicina</span>
                </h1>
                <p class="text-surface-600 dark:text-surface-400 text-lg md:text-xl mb-8 max-w-2xl leading-relaxed">
                    A nova experiência com o <span class="font-bold text-primary">SICOM</span> otimiza a administração com módulos específicos para cada área, garantindo eficiência e transparência.
                </p>
            </div>
            <div class="flex-1 hidden lg:flex justify-center relative">
                <div
                    class="w-84 h-84 rounded-[4.5rem] rotate-3 flex flex-col items-center justify-center shadow-2xl relative z-10 border-4 border-emerald-500 hover:rotate-0 hover:scale-105 transition-all duration-700 cursor-pointer overflow-hidden group"
                >
                    <div class="flex flex-col items-center justify-center">
                        <img src="images/logos/sicom.svg" class="w-60 h-auto mt-0" alt="Icone de médico" />
                        <span class="text-3xl text-emerald-500 font-bold">SICOM</span>
                    </div>
                </div>
                <div class="absolute inset-0 bg-primary/30 blur-[130px] -z-10 animate-pulse"></div>
            </div>
        </div>
    </section>

    <div class="flex flex-wrap justify-center content-start gap-8 w-[90%] px-4 py-4 overflow-y-auto pt-15 items-stretch">
        @for (item of menuItemsWithRoutes(); track item.label) {
            <app-card-container
                class="w-full max-w-80 flex flex-col"
                (click)="navigateToRoute(item)"
                [ribbon]="item.estado !== 'normal'"
                [ribbonColor]="'var(--primary-color)'"
                [ribbonText]="item.estado === 'sem-acesso' ? 'RESTRITO' : item.ribbon?.text || ''"
                [popover]="item.estado !== 'normal'"
            >
                <div class="flex flex-col justify-center items-center p-4 gap-4 w-full h-full" [class.opacity-50]="item.estado === 'sem-acesso'">
                    <div class="text-primary w-12 h-12 flex items-center justify-center">
                        <i [class]="item.icon || 'pi pi-user'" class="!text-3xl"></i>
                    </div>
                    <span class="text-2xl font-bold text-center">{{ item.label }}</span>
                    <span class="text-muted-color text-center leading-relaxed">{{ item.description }}</span>
                </div>

                <div popover-info class="animate-popover max-w-[320px] rounded-[2rem] backdrop-blur-2xl p-7">
                    @if (item.estado === 'sem-acesso') {
                        <app-acesso-negado></app-acesso-negado>
                    } @else {
                        <app-acesso-em-breve></app-acesso-em-breve>
                    }
                </div>
            </app-card-container>
        }
    </div>

    <section class="w-[90%] flex flex-col items-center">
        <div class="flex flex-col w-full justify-center items-center pt-32">
            <h2 class="text-4xl font-bold text-center leading-tight mb-4">
                Módulos de Gestão com foco em
                <span class="text-primary">Controle e Supervisão</span>
            </h2>
            <p class="text-center mt-0 mb-12 text-surface-500 dark:text-surface-400 font-medium text-lg md:text-xl leading-relaxed max-w-4xl">
                Painel de controle exclusivo para gestão estratégica. Acesse ferramentas de monitoramento e análise de dados para uma administração eficiente.
            </p>
        </div>
        <div class="flex flex-wrap justify-center content-start gap-8 w-full px-4 py-4 overflow-y-auto pt-15 items-stretch">
            @for (item of gestaoMenuItemsWithRoutes; track item) {
                <app-card-container
                    [leftBorder]="true"
                    class="w-full max-w-120 flex flex-col"
                    (click)="navigateToRoute(item)"
                    [ribbon]="item.estado !== 'normal'"
                    [ribbonColor]="'var(--primary-color)'"
                    [ribbonText]="item.estado === 'sem-acesso' ? 'RESTRITO' : item.ribbon?.text || ''"
                    [popover]="item.estado !== 'normal'"
                >
                    <div class="flex flex-col justify-center items-center p-4 gap-4 w-full h-full" [class.opacity-50]="item.estado === 'sem-acesso'">
                        <div class="text-primary w-12 h-12 flex items-center justify-center">
                            <i [class]="item.icon || 'pi pi-user'" class="!text-3xl"></i>
                        </div>
                        <span class="text-2xl font-bold text-center">{{ item.label }}</span>
                        <span class="text-muted-color text-center leading-relaxed">{{ item.description }}</span>
                    </div>

                    <div popover-info class="animate-popover max-w-[320px] rounded-[2rem] backdrop-blur-2xl p-7">
                        @if (item.estado === 'sem-acesso') {
                            <app-acesso-negado></app-acesso-negado>
                        } @else {
                            <app-acesso-em-breve></app-acesso-em-breve>
                        }
                    </div>
                </app-card-container>
            }
        </div>
    </section>

    @if (servicosCfm().length) {
        <section class="w-[90%] flex flex-col items-center pt-15">
            <div class="flex flex-col lg:flex-row w-full gap-8 items-stretch pt-32">
                <aside class="w-full lg:w-[30%] flex flex-col justify-between py-12 border-l-4 border-primary pl-8 bg-surface-50 dark:bg-surface-900/50 rounded-r-3xl">
                    <div class="w-[90%]">
                        <h2 class="text-4xl md:text-5xl font-extrabold mb-6 leading-none tracking-tighter uppercase">
                            Plataformas e <br />
                            Soluções <br />
                            Digitais do <br />
                            <span class="text-primary text-6xl max-w-[280px]">CFM</span>
                        </h2>
                        <p class="text-surface-600 dark:text-surface-400 text-lg leading-relaxed mt-4">
                            A transformação digital chegou para facilitar o seu trabalho. Neste espaço, o CFM disponibiliza um ecossistema completo de plataformas integradas e seguras, desenhado para otimizar o seu tempo. Com apenas alguns cliques,
                            tenha acesso rápido aos serviços mais requisitados, desde a emissão ágil de receitas eletrônicas e atestados, até a consulta de dados de registro e gerenciamento de anuidades. Navegue pelas nossas soluções e aproveite
                            todas as facilidades criadas para apoiar o seu dia a dia.
                        </p>
                    </div>
                </aside>

                <div class="flex-1">
                    <div class="flex flex-wrap justify-center content-start gap-8 w-full px-4 py-4 overflow-y-auto pt-15 items-stretch">
                        @for (servico of servicosCfm(); track servico.codigo) {
                            <app-card-container pAnimateOnScroll enterClass="animate-enter fade-in-10 slide-in-from-l-8 animate-duration-1000" class="w-full max-w-80 flex flex-col cursor-pointer" (click)="navigateToExternalUrl(servico.url)">
                                <div class="flex flex-col justify-center items-center p-8 gap-4 w-full h-full">
                                    <div class="text-primary w-16 h-16 flex items-center justify-center bg-primary/10 rounded-2xl shrink-0">
                                        <i [class]="(servico.icon || 'pi pi-th-large') + ' !text-3xl'" aria-hidden="true"></i>
                                    </div>
                                    <span class="text-2xl font-bold text-center">{{ servico.servico }}</span>
                                    <span class="text-muted-color text-center leading-relaxed">{{ servico.descricao }}</span>
                                </div>
                            </app-card-container>
                        }
                    </div>
                </div>
            </div>
        </section>
    }

    @if (servicosPortal().length) {
        <section class="w-[90%] flex flex-col items-center">
            <div class="flex flex-col w-full justify-center items-center pt-32">
                <h2 class="text-4xl font-bold text-center leading-tight mb-4">
                    Plataformas e Soluções do
                    <span class="font-bold text-primary">{{ regional() }}</span>
                </h2>
                <p class="text-center mt-0 mb-12 text-surface-500 dark:text-surface-400 font-medium text-lg md:text-xl leading-relaxed max-w-4xl">
                    Conheça os serviços e sistemas exclusivos do {{ regional() }}. Acesse ferramentas e recursos desenvolvidos para atender às necessidades dos médicos.
                </p>
            </div>

            <div class="flex flex-wrap justify-center content-start gap-8 w-full px-4 py-4 overflow-y-auto pt-15 items-stretch pb-20">
                @for (servico of servicosPortal(); track servico.codigo) {
                    <app-card-container pAnimateOnScroll enterClass="animate-enter fade-in-10 zoom-in-75 animate-duration-1000" class="w-full max-w-80 flex flex-col cursor-pointer" (click)="navigateToExternalUrl(servico.url)">
                        <div class="flex flex-col justify-center items-center p-8 gap-4 w-full h-full">
                            <div class="text-primary w-16 h-16 flex items-center justify-center bg-primary/10 rounded-2xl shrink-0">
                                <i [class]="(servico.icon || 'pi pi-th-large') + ' !text-3xl'" aria-hidden="true"></i>
                            </div>
                            <span class="text-2xl font-bold text-center">{{ servico.servico }}</span>
                            <span class="text-muted-color text-center leading-relaxed">{{ servico.descricao }}</span>
                        </div>
                    </app-card-container>
                }
            </div>
        </section>
    }
</div>
